import { toLocalEquivalentUtcDate } from "svila-common";
import { OrderEditFormikDto } from "../OrderEditFormikDto";
import { OrderGetMinDto } from "../OrderGetMinDto";

export const orderGetMinDtoToFormik = (item: OrderGetMinDto): OrderEditFormikDto => {
  const formik: OrderEditFormikDto = {
    customerId: item?.customerId ?? '',
    palletId: item?.palletId ?? '',
    containerId: item?.containerId ?? '',
    shippingType: item?.shippingType,

    palletMaxWidth: nullableNumberToString(item.palletMaxWidth),
    palletMaxHeight: nullableNumberToString(item.palletMaxHeight),
    palletMaxLength: nullableNumberToString(item.palletMaxLength),
    maxKg: nullableNumberToString(item.maxKg),
    dateOfTransaction: toLocalEquivalentUtcDate(item.dateOfTransaction) ?? '',
    dateOfTransport: toLocalEquivalentUtcDate(item.dateOfTransport) ?? '',
    destination: item?.destination,
    containerLine: item?.containerLine,
    containerNo: item?.containerNo,
    vesselFlag: item?.vesselFlag,
    truckTrailer: item?.truckTrailer,
    routing: item?.routing,
    palletsDescription: item?.palletsDescription,
    totalWeightOfOrder: nullableNumberToString(item.totalWeightOfOrder),
    salesTerm: item?.salesTerm,
    paymentTerm: item?.paymentTerm,
    cosigneeName: item?.cosigneeName,
    cosigneeAddress: item?.cosigneeAddress,
    warehouseOwnerId: item?.warehouseOwnerId ?? '',
  };
  return formik;
};

export const nullableNumberToString = (nullableNumber: number | null): string => {
  if (nullableNumber) {
    return nullableNumber.toString();
  }
  return '';
};